module.exports = __webpack_public_path__ + "static/img/null.f16c427c.png";